import Api from "./baseApi";

const state = {
  all: [],
  versions: [],
  detail: {},
};
const getters = {
  setting: (state) => {
    return state.setting;
  },
};
const actions = {
  getAll: async (context) => {
    let url = `/admin/apis`;
    let d = (await Api.get(url)).data;
    context.commit("getAll", d);
  },
  getAllVersions: async (context) => {
    let url = `/admin/versions`;
    let d = (await Api.get(url)).data;
    context.commit("getAllVersions", d);
  },
  updateVersion: async (context, data) => {
    let url = `/admin/versions/${data.id || data.version}`;
    (await Api.put(url, data)).data;
  },
  updateAllVersion: async (context, data) => {
    let url = `/admin/versions`;
    (await Api.post(url, data)).data;
  },
  update: async (context, data) => {
    let url = `/admin/apis/${data.name}`;
    let d = (await Api.put(url, data)).data;
    context.commit("update", d);
  },
  post: async (context, data) => {
    let url = `/admin/apis`;
    (await Api.post(url, data)).data;
  },
  get: async (context, id) => {
    context.commit("get", id);
  },
};
const mutations = {
  getAll(state, settings) {
    state.all = settings;
  },
  getAllVersions(state, settings) {
    state.versions = settings;
  },
  get(state, id) {
    state.detail = state.all.find((m) => m.id == id);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
